<template>
  <LoadingOverlay :active.sync="active"
                  :is-full-page="fullPage"
                  color="blue"
                  :width="96"
                  :height="96"
                  style="z-index: 99999;"
  />
</template>

<script>
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Loading",

  components: {
    LoadingOverlay
  },

  data() {
    return {
      active: false,
      tid: null,
      fullPage: true
    };
  },

  watch: {
    "$store.state.progress.count": function() {
      if (this.$store.state.progress.count > 0) {
        if (!this.active && this.tid === null)
          this.tid = setTimeout(() => this.active = true, 500);
      } else {
        // pokud je aktivni timeout zruš ho
        if (this.tid !== null) {
          clearTimeout(this.tid);
          this.tid = null;
        }
        // zkryj loading, pokud je zobrazen
        if (this.active)
          this.active = false;
      }
    }
  }
};
</script>